// Lista de nacionalidades para el combo con búsqueda del formulario de solicitud.
// Se deduplica preservando el orden de aparición.
const LISTA = [
  "AFGANO", "ALANDÉS", "ALBANÉS", "ALEMÁN", "ANDORRANO", "ANGOLEÑO",
  "ANGUILENSE", "ANTIGUANO", "SAUDÍ", "ARGELINO", "ARGENTINO", "ARMENIO",
  "ARUBEÑO", "AUSTRALIANO", "AUSTRÍACO", "AZERBAIYANO", "BAHAMEÑO",
  "BANGLADESÍ", "BARBADENSE", "BAREINÍ", "BELGA", "BELICEÑO", "BENINÉS",
  "BERMUDEÑO", "BIELORRUSO", "BOLIVIANO", "BONAIRENSE", "BOSNIO", "BOTSUANO",
  "BRASILEÑO", "BRUNEANO", "BÚLGARO", "BURKINÉS", "BURUNDÉS", "BUTANÉS",
  "CABOVERDIANO", "CAMBOYANO", "CAMERUNÉS", "CANADIENSE", "CATARÍ", "CHADIANO",
  "CHILENO", "CHINO", "CHIPRIOTA", "VATICANO", "COLOMBIANO", "COMORENSE",
  "NORCOREANO", "SURCOREANO", "MARFILEÑO", "COSTARRICENSE", "CROATA", "CUBANO",
  "CURAZOLEÑO", "DANÉS", "DOMINIQUÉS", "ECUATORIANO", "EGIPCIO", "SALVADOREÑO",
  "EMIRATÍ", "ERITREO", "ESLOVACO", "ESLOVENO", "ESPAÑOL", "ESTADOUNIDENSE",
  "ESTONIO", "SUAZI", "ETÍOPE", "FILIPINO", "FINLANDÉS", "FIYIANO", "FRANCÉS",
  "GABONÉS", "GAMBIANO", "GEORGIANO", "GHANÉS", "GIBRALTAREÑO", "GRANADINO",
  "GRIEGO", "GROENLANDÉS", "GUADALUPEÑO", "GUAMEÑO", "GUATEMALTECO",
  "GUAYANÉS FRANCÉS", "GUERNESIANO", "GUINEANO", "ECUATOGUINEANO",
  "BISAUGUINEANO", "GUYANÉS", "HAITIANO", "HONDUREÑO", "HONGKONÉS", "HÚNGARO",
  "INDIO", "INDONESIO", "IRAQUÍ", "IRANÍ", "IRLANDÉS", "MANÉS", "NAVIDEÑO",
  "NORFOLKENSE", "ISLANDÉS", "CAIMANÉS", "COCANO", "COOKIANO", "FEROÉS",
  "MALVINENSE", "NORMARIANO", "MARSHALÉS", "PITCAIRNÉS", "SALOMONENSE",
  "TURCOCAICENSE", "VIRGENENSE BRITÁNICO", "VIRGENENSE ESTADOUNIDENSE",
  "ISRAELÍ", "ITALIANO", "JAMAIQUINO", "JAPONÉS", "JERSEYÉS", "JORDANO",
  "KAZAJO", "KENIANO", "KIRGUÍS", "KIRIBATIANO", "KUWAITÍ", "LAOSIANO",
  "LESOTENSE", "LETÓN", "LIBANÉS", "LIBERIANO", "LIBIO", "LIECHTENSTEINIANO",
  "LITUANO", "LUXEMBURGUÉS", "MACAENSE", "MACEDONIO", "MALGACHE", "MALASIO",
  "MALAUÍ", "MALDIVO", "MALIENSE", "MALTÉS", "MARROQUÍ", "MARTINIQUÉS",
  "MAURICIANO", "MAURITANO", "MAHORÉS", "MEXICANO", "MICRONESIO", "MOLDAVO",
  "MONEGASCO", "MONGOL", "MONTENEGRINO", "MONTSERRATENSE", "MOZAMBIQUEÑO",
  "BIRMANO", "NAMIBIO", "NAURUANO", "NEPALÍ", "NICARAGÜENSE", "NIGERINO",
  "NIGERIANO", "NIUEANO", "NORUEGO", "NEOCALEDONIO", "NEOZELANDÉS", "OMANÍ",
  "NEERLANDÉS", "PAKISTANÍ", "PALAUANO", "PALESTINO", "PANAMEÑO", "PAPÚ",
  "PARAGUAYO", "PERUANO", "POLINESIO", "POLACO", "PORTUGUÉS", "PUERTORRIQUEÑO",
  "BRITÁNICO", "CENTROAFRICANO", "CHECO", "CONGOLEÑO", "DOMINICANO",
  "REUNIONÉS", "RUANDÉS", "RUMANO", "RUSO", "SAHARAUI", "SAMOANO",
  "SAMOANO ESTADOUNIDENSE", "SANBARTOLOMEANO", "SANCRISTOBALEÑO",
  "SANMARINENSE", "SANMARTINENSE", "SAMPEDRINO", "SANVICENTINO", "SANTAHELENO",
  "SANTALUCENSE", "SANTOTOMENSE", "SENEGALÉS", "SERBIO", "SEYCHELLENSE",
  "SIERRALEONÉS", "SINGAPURENSE", "SANMARTINENSE NEERLANDÉS", "SIRIO",
  "SOMALÍ", "ESRILANQUÉS", "SUDAFRICANO", "SUDANÉS", "SURSUDANÉS", "SUECO",
  "SUIZO", "SURINAMÉS", "SVALBARDENSE", "TAILANDÉS", "TAIWANÉS", "TANZANO",
  "TAYIKO", "TIMORENSE", "TOGOLÉS", "TOKELAUANO", "TONGANO", "TRINITENSE",
  "TUNECINO", "TURCOMANO", "TURCO", "TUVALUANO", "UCRANIANO", "UGANDÉS",
  "URUGUAYO", "UZBEKO", "VANUATUENSE", "VENEZOLANO", "VIETNAMITA", "WALISIANO",
  "YEMENÍ", "YIBUTIANO", "ZAMBIANO", "ZIMBABUENSE",
];

const NACIONALIDADES: string[] = Array.from(new Set(LISTA));

export default NACIONALIDADES;
